angular.module('core')
  .service('assignMode', ['$state', '$rootScope', 'navigationTabsService', 'authentication', 'customer', 'configuration', function ($state, $rootScope, $navigationTabs, $authentication, $customer, $configuration) {

      var fromPane = null;
      var publics = {};

      publics.isAssignMode = false;
      publics.assignStatus = {};


      $rootScope.$on('$stateChangeSuccess', function (e, to, toParams, from, fromParams) {
          publics.isAssignMode = ($state.params.assign === 'true');
          if (!fromParams.assign || fromParams.assign === 'false') {
              fromPane = fromParams.pane;
          }
      });

      $rootScope.$on('assignStatusChange', function (e, statusObj) {
          publics.assignStatus = statusObj;
      });

      publics.enableAddAssignment = function() {
          publics.assignStatus = {allowSave: true};
      };

      publics.disableAddAssignment = function() {
          publics.assignStatus = {allowSave: false};
      };

      publics.assignmentsAllowed = function () {
          // The user must be flagged to enable lesson assignment
          return $authentication.canAssignLessons($authentication.getCustomer());
      };

      publics.currentStandardAllowed = function () {
          var allowedAsts = $configuration.allowedAsts('assign_focus');
          var currentStandardName = $customer.getAcademicStandard().academic_standard_name;

          return _.contains(allowedAsts, currentStandardName);
      };

      publics.onClickAssignMode = function (focusType) {
        // Check if the user was directed here directly from the new (Angular 8+) dashboard. This is distinct from
        // other checks that the user navigated to an AngularJS dashboard page, because we don't necessarily want to
        // always navigate directly back to the new dashboard upon creating the assignment. We want to preserve the
        // navigation history, so if the user gets here via another AngularJS page, this will take them back to that
        // page. Theoretically, this has the same problem, since it uses local storage in the exact same way, but since
        // the Create Assignment page is a navigational dead end, there's no risk of the user reentering this page while
        // an old value of "createAssignmentFromNewDashboard" is still in storage.
        if(publics.isAssignMode && $authentication.useBts2020Nav() && localStorage.getItem('createAssignmentFromNewDashboard') === 'true'){
          localStorage.removeItem('createAssignmentFromNewDashboard');

          var referringPage = localStorage.getItem('referringPage');

          if (!!referringPage) {
            localStorage.removeItem('referringPage');
            location.assign(referringPage);
          } else { // go to default page
            location.assign($authentication.getCustomerDefaultUrl());
          }
        } else {
          if (_.isUndefined(focusType)) {
            publics.focusType = $state.params.focusType;
          } else {
              publics.focusType = focusType;
          }

          var params = angular.copy($state.params);

          var assign = (publics.isAssignMode) ? 'false' : 'true';
          params.assign = assign;

          params.pane = fromPane;

          var pane = $navigationTabs.getTabSlug($state.current.name, assign, params);
          var url =  !$authentication.getCustomer().isGuardian() ? 'add-assignment' : '.';
          if($state.params.standards){
            var isCluster = publics.focusType === 'cluster' ? '1f' : 'f';
            localStorage.setItem('stateParams', $state.params.standards + ',' + isCluster);
          }
          $state.go(url, {
            'assign': assign,
            'pane': pane
          });
        }
      };

      publics.onCreateAssignmentSuccess = function () {
          fromPane = 'assignments';
          publics.onClickAssignMode();
      };

      publics.onCreateAssignmentRejected = function(rejection) {
          if (rejection.status === 400) {
              $rootScope.$broadcast('assignmentNotValid', rejection);
          }
      };

      return publics;

  }]);
